<template>
  <b-modal id="modal-confirm-delete-file" header-class="danger">
    <template #modal-header>
      <div class="d-inline-flex justify-content-between w-100">
        <div> 
          <h5> {{$t('engine.filemanager.folder.confirmDeleteItem.lblTitle', languageEngine)}} </h5>
        </div>
        <div class="d-flex">
          <div class="mr-gd-1">
            <i class="fal fa-question-circle"></i>
          </div>
          <div
            @click="closeModal()"
            id="close-modal-confirm-delete-file"
            class="close-modal cursor-pointer"
          >
            <i class="fal fa-times"></i>
          </div>
        </div>
      </div>
    </template>
    <template>
      <div>
        {{$t('engine.filemanager.folder.confirmDeleteItem.lblDetail', languageEngine)}}
      </div>
    </template>
    <template #modal-footer>
      <b-button variant="danger" @click="confirm"><i class="far fa-trash-alt"></i> {{$t('engine.common.btnDelete', languageEngine)}}</b-button>
      <b-button variant="light" @click="closeModal" class="mr-3"> <i class="far fa-times"></i> {{$t('engine.common.btnCancel', languageEngine)}}</b-button>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({
      languageEngine: "design/userPreference/languageEngine",
    }),
  },
  methods: {
    closeModal() {
      this.$emit('clear');
      this.$bvModal.hide("modal-confirm-delete-file");
    },
    confirm() {
      this.$emit('confirmed');
      this.$bvModal.hide("modal-confirm-delete-file");
    }
  },
}
</script>